import type { $Fetch } from 'ofetch';
import type { AlertaVenda, AlertaVendaStatus, DeferirAlertaCommand, IndeferirAlertaCommand } from '@/domain/model/AlertaVenda';
import type { Page } from '@/domain/model/Page';
import type { AlertaVendaGateway } from '@/application/port/out/AlertaVendaGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/alertas-venda';

export class HttpAlertaVendaGateway implements AlertaVendaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { status?: AlertaVendaStatus; vendedorUserId?: string; page?: number; size?: number }): Promise<Page<AlertaVenda>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.vendedorUserId) params['vendedorUserId'] = p.vendedorUserId;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<AlertaVenda>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<AlertaVenda> {
    const res = await this.client<ApiResponse<AlertaVenda>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async deferir(id: string, command: DeferirAlertaCommand): Promise<AlertaVenda> {
    const res = await this.client<ApiResponse<AlertaVenda>>(
      `${PATH}/${encodeURIComponent(id)}/deferir`, { method: 'POST', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async indeferir(id: string, command: IndeferirAlertaCommand): Promise<AlertaVenda> {
    const res = await this.client<ApiResponse<AlertaVenda>>(
      `${PATH}/${encodeURIComponent(id)}/indeferir`, { method: 'POST', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
